/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import PropTypes from "prop-types";
import { getToken, getRole } from "utils";

const PrivateRoute = ({ component: Component, userRole, ...rest }) => {
  if (!getToken() && rest.location.pathname !== "/login") {
    // If we’re not logged in, redirect to the login page.
    window.location.href = "/login";
    return null;
  }

  // get role from cookie
  const userRolePrivate = getRole();

  if (userRolePrivate !== userRole) {
    window.location.href = "/login";
    return null;
  }

  return <Component {...rest} />;
};

export default PrivateRoute;

PrivateRoute.propTypes = {
  component: PropTypes.any.isRequired,
};
